import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Import images

const CollegesSlider = () => {
  const [personalInfo, setPersonalInfo] = useState([]);
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state

  const fetchTopCollege = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getInstitutesData`);
      setPersonalInfo(response.data.data.personalInfo);
      setProfileImg(response.data.data.profileImg);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopCollege();
  }, []); 
  return (
    <div className="institute-slider-container event-slider">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading institutes...</p>
      ) : profileImg.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {profileImg.map((profile, index) => (
            <div className="item event-item" key={profile.id}>
              <div className="course-img">
                <span class="course-tag2"> IIT Bombay - Indian Institute of Technology - [IITB]</span>
                <img src={`${Image_Base_Url}${profile.profile_image_path}`} alt="College" />
              </div>
              <div className="course-meta pd_20 pb-0">
                <span class="course-meta-left"><i class="far fa-book"></i> BE/B.Tech</span>
                <div class="course-rating">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="far fa-star"></i>
                  <span>(4.0)</span>
                </div>
              </div>
              <div class="course-content pd_20">
                <div class="course-bottom">
                  <div class="course-bottom-left">
                    <span>2.31 Lacs First Year Fees</span> 
                  </div> 
                  <span class="course-price">300 Reviews</span>
                </div>
                <div class="course-bottom">
                  <div class="course-bottom-left">
                    <span>View All Courses and fees</span> 
                  </div> 
                  <span><a href="#"><i class="far fa-arrow-right"></i></a></span>
                </div> 
                <div class="course-bottom">
                  <div class="course-bottom-left">
                    <span>Download Brochure</span> 
                  </div> 
                  <span><a href="#"><i class="far fa-download"></i></a></span>
                </div> 
              </div>  
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <p>No institutes available.</p>
      )}
    </div>
  );
};

export default CollegesSlider;